import React, { Component } from 'react';
import {Form, Control, Fieldset, Errors} from 'react-redux-form';
import {isRequired/*, required*/} from "../field_validations";
import _ from "lodash";
import BigFileUpload from "../widgets/big_file_upload";
import {toInt} from "../parsers";
import {confirmAlert} from "react-confirm-alert";

export default class ContentFormPhase extends Component {
	render(){
		const {phases, modalities} = this.props;
		return(
			<div className="columns is-centered">
				<div className="column is-10">
					<Form model="phases.edit" onSubmit={(values) => this._handleSubmit(values)} onSubmitFailed={(error) => {this.props.setSystemNotification('¡Oh no!', 'Hay errores en el formulario', 'danger'); console.log('error', error)}}>
						{this.state.documentEditForm &&
							<DocumentEditForm
								document_index={this.state.document_index}
								active={this.state.documentEditForm}
								closeModal={() => this._toggleModal()}
								{...this.props}
							/>
						}

						<div className="hero is-light">
							<div className="hero-body">
								<div className="field is-grouped">
									<div className="control is-expanded">
										<label htmlFor="name" className="label">Nombre del Sub-proceso <span className="small has-text-danger">*</span></label>
										<Control.text model=".name" id="name" className="input" placeholder="Nombre de la Meta" errors={{isRequired}} validateOn="change"/>
										<Errors model=".name" show="touched" wrapper={(props)=> <small className="help has-text-danger">{props.children}</small>} messages={{ isRequired: 'El nombre es obligatorio'}} />
									</div>

									{/*<div className="control">
										<br/>
										<label htmlFor="reportable" className="checkbox">
											<Control.checkbox model=".reportable" id="reportable" isToggle={true}/>
											Obligatorio
										</label>
									</div>*/}
								</div>
							</div>
						</div>

						<hr />

						<div className="field is-grouped is-grouped-right">
							<div className="control">
								<button type="button" className="button is-primary" onClick={() => this._addDocument()}>
					        <span className="icon">
					            <i className="fa fa-plus" />
					        </span>
									<span>Agregar Documento</span>
								</button>
							</div>
						</div>

						{phases.edit && !_.isEmpty(phases.edit.documents_items) ?
							<div className="hero is-light">
								<div className="hero-body">
									<h5 className="title is-5">Lista de Documentos</h5>
									<table className="table is-fullwidth is-bordered">
										<thead>
										<tr>
											<th>#</th>
											<th>Documento</th>
											<th>Tipo</th>
											<th>Categoría</th>
											<th>Acciones</th>
										</tr>
										</thead>
										<tbody>
										{_.map(phases.edit.documents_items, (row, k) => {
											let type = _.find(phases.edit.documentables_types,{slug: row.documentable_type})
											let modality = _.find(modalities.list, {id: row.modality_id})
											return (
												<tr key={k}>
													<td><strong>{k+1}</strong>
													</td>
													<td >{row.name}</td>
													<td>{type ? type.name:'---'}</td>
													<td>{modality ? modality.name:'---'}</td>
													<td style={{width:'10%'}}>
														<div className="field is-grouped">
															<div className="control">
																<button type="button" className="button is-info" onClick={() => this._editDocument(row,k)}><i className="fa fa-edit" /></button>
															</div>
															<div className="control">
																<button type="button" onClick={() => this._getConfirm(k,row.name)} className="button is-danger"><i className="fa fa-trash" /></button>
															</div>
														</div>
													</td>
												</tr>
											)
										})}
										</tbody>
									</table>
								</div>
							</div>:''}

						<br/>

						<div className="field is-grouped is-grouped-right">
							<div className="control">
								<button type="button" className="button is-large" onClick={() => this.props.history.push('/fases')}>
									Regresar
								</button>
							</div>
							<div className="control">
								<Control.button model="phases.edit" className="button is-primary is-large" type="submit" disabled={this._validateSave()}>
									Guardar
								</Control.button>
							</div>
						</div>
					</Form>
				</div>
			</div>
		);
	}

	constructor(){
		super();
		this.state = {
			document_index: undefined,
			documentEditForm: false
		}
	}

	_handleSubmit(values) {
		this.props.phaseSave(values)
		//console.log('values==>', values);
	}

	_addDocument(){
		this.setState({
			documentEditForm: true
		})
	}

	_editDocument(data, index){
		this.props.change('phases.edit.document',{
			...data
		})

		this.setState({
			document_index: index,
			documentEditForm: true
		})
	}

	_getConfirm(index, name){
		confirmAlert({
			title: '¿Está seguro?',
			message: `¿Estás seguro/(a) de eliminar el documento "${name}"?`,
			confirmLabel: 'Aceptar',
			cancelLabel: 'Cancelar',
			onConfirm: () => this.props.remove('phases.edit.documents_items', index)
		})
	}

	_toggleModal() {
		this.setState({
			document_index: undefined,
			documentEditForm: false
		});

		this.props.change('phases.edit.document', {})
	}

	_validateSave(){
		const {phases} = this.props;
		let pc = _.find(phases.permissions, (o) => {return o==='Create'});
		let pu = _.find(phases.permissions, (o) => {return o==='Update'});

		if(!_.isEmpty(phases.edit) && phases.edit.id){
			if(pu){
				return false;
			}else {
				return true;
			}
		}else if(!_.isEmpty(phases.edit) && _.isEmpty(phases.edit.id)){
			if(pc){
				return false;
			}else {
				return true;
			}
		}else {
			return true;
		}
	}
}

//export default ContentFormPhase;

class DocumentEditForm extends Component{
	render(){
		const {phases, modalities, documents_types} = this.props;
		console.log('phases.edit ====>', phases);
		return (
			<div className={`modal${this.props.active ? ' is-active' : ''}`}>
				<div className="modal-background" onClick={this.props.closeModal} />
				<div className="modal-card">
					<header className="modal-card-head">
						<p className="modal-card-title">Editar Documento</p>
						<button type="button" onClick={this.props.closeModal} className="delete" aria-label="close" />
					</header>
					<Fieldset model=".document" className="modal-card-body">
						<div className="field is-grouped">
							<div className="control is-expanded">
								<label htmlFor="name" className="label">Nombre del documento <span className="small has-text-danger">*</span></label>
								<Control.text model=".name" id="name" className="input" placeholder="Nombre del documento"/>
								{phases.edit.document && phases.edit.document.name ? '':<small className="help has-text-danger">El nombre es obligatorio</small>}
							</div>

							<div className="control">
								<label htmlFor="documentable_type" className="label">Tipo de documento <span className="small has-text-danger">*</span></label>
								<div className="select" >
									<Control.select model=".documentable_type" id="documentable_type">
										<option value=""> -- Tipo de documento --</option>
										{_.map(phases.edit.documentables_types, (opt, k) => {
											return <option key={k} value={opt.slug}>{opt.name}</option>
										})}
									</Control.select>
								</div>
								{phases.edit.document && phases.edit.document.documentable_type ? '':<small className="help has-text-danger">El tipo de documento es obligatorio</small>}
							</div>
						</div>

						<div className="field">
							<div className="control">
								<label htmlFor="description" className="label">Descripción</label>
								<Control.textarea model=".description" id="description" className="textarea" value={phases.edit.document && phases.edit.document.description ? phases.edit.document.description:''} placeholder="Descripción"/>
							</div>
						</div>

						<div className="field is-grouped">
							<BigFileUpload
								name="Formato"
								model=".file_format"
								file={phases.edit.document && !_.isEmpty(phases.edit.document.file_format) ? phases.edit.document.file_format:undefined}
							/>

							<div className="control">
								<div className="message is-primary">
									<div className="message-body">
										<div className="field">
											<div className="control">
												<label htmlFor="all_mods" className="checkbox">
													<input id="all_mods" type="checkbox" className="checkbox" checked={this.state.all_mods} onChange={() => this._changeAllMods()}/>
													{/*<Control.checkbox model=".all_mods" id="all_mods" className="checkbox" isToggle={true}/>*/}
													<span style={{whiteSpace:'normal'}}> Todas las modalidades</span>
												</label>
											</div>
										</div>
									</div>
								</div>
							</div>

							{!this.state.all_mods ?
							<div className="control">
								<label htmlFor="modality_id" className="label">Modalidad </label>
								<div className={`select${modalities.isFetching ? ' is-loading':''}`} >
									<Control.select model=".modality_id" id="modality_id" parser={ toInt } disabled={modalities.isFetching}>
										<option value=" " defaultValue>--- Modalidad ---</option>
										{_.map(modalities.list,(option, k) => {
											return <option value={option.id} key={k}>{option.name}</option>
										})}
									</Control.select>
								</div>
							</div>:''}
						</div>

						{!this.state.all_mods && phases.edit.document && phases.edit.document.modality_id === 2 ?
						<div className="field is-grouped">
							<div className="control">
								<label htmlFor="agency_type" className="label">Tipo de Instancia </label>
								<div className="select">
									<Control.select model=".agency_type"
									                id="agency_type">
										<option value="" defaultValue>--- Tipo de Instancia ---</option>
										<option value="centralized">Centralizada</option>
										<option value="decentralized">Descentralizada</option>
										<option value="delegacy">Delegación</option>
									</Control.select>
								</div>
							</div>
						</div>:''}

						<label className="label">Extensiones admitidas <span className="small has-text-danger">*</span></label>
						<div className="field is-grouped is-grouped-multiline">
							{_.map(documents_types.list, (item,k) => {
								let checked =phases.edit.document && !_.isEmpty(phases.edit.document.documents_types) && _.find(phases.edit.document.documents_types, {id: item.id}) ? true:false;

								return (
									<div className="control" key={k}>
										<div className="message is-success">
											<div className="message-body">
												<div className="field">
													<div className="control">
														<label htmlFor={`extensions-${item.id}`} className="checkbox">
															<input id={`extensions-${item.id}`} type="checkbox" className="checkbox" checked={checked} onChange={() => this._changeExtension(item.id, checked)}/>
															<span style={{whiteSpace:'normal'}}>{item.name}</span>
														</label>
													</div>
												</div>
											</div>
										</div>
									</div>
								)
							})}
						</div>
						{phases.edit.document && !_.isEmpty(phases.edit.document.documents_types) ? '':<small className="help has-text-danger">Seleccionar una extensión</small>}

						<div className="field is-grouped is-grouped-right">
							<div className="control">
								<button type="button" className="button" onClick={this.props.closeModal}>Cerrar</button>
							</div>
							<div className="control">
								<button type="button" className="button is-primary" onClick={() => this._saveDocument()}>Guardar</button>
							</div>
						</div>
						<p className="has-text-grey has-text-right is-small">Los campos indicados con <span className="small has-text-danger">*</span> son obligatorios.</p>
					</Fieldset>
				</div>
			</div>
		)
	}

	constructor(){
		super();
		this.state = {
			all_mods: true
		}
	}

	componentWillMount(){
		const {phases} = this.props;

		if(!_.isEmpty(phases.edit.document) && phases.edit.document.modality_id){
			this.setState({
				all_mods: false
			})
		}
	}

	_changeAllMods(){
		this.props.change('phases.edit.document.modality_id',undefined);
		this.setState({
			all_mods: !this.state.all_mods
		})
	}

	_changeExtension(typeId, checked){
		const {documents_types, phases} = this.props;
		if(checked){
			let index = _.findIndex(phases.edit.document.documents_types,{id: typeId})
			this.props.remove('phases.edit.document.documents_types', index);
		}else {
			let extension = _.find(documents_types.list, {id: typeId})
			this.props.add('phases.edit.document.documents_types', extension);
		}
	}

	_saveDocument(){
		const {phases, document_index} = this.props;
		let {document} = phases.edit;
		if(document.name && document.documentable_type && !_.isEmpty(document.documents_types)){
			if(_.isNumber(document_index)){
				this.props.change( `phases.edit.documents_items[${document_index}]`,{
					...phases.edit.documents_items[document_index],
					...phases.edit.document
				})
			}else {
				this.props.add('phases.edit.documents_items',{
					...phases.edit.document
				})
			}
			this.props.closeModal();
		}else {
			alert('Hay errores en el formulario');
		}
	}
}


// WEBPACK FOOTER //
// ./src/elements/phases/form.jsx